module.exports = __webpack_public_path__ + "static/media/header-7.5b4a38e0.png";